module.exports = __webpack_public_path__ + "img/logo-mydocbase.d08f0536.png";